//#region imports
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { Pricing, TarifCheckboxStatus } from '../../model/guarantee.model';
import { DecimalPipe } from '@angular/common';
import { SummaryService } from 'src/app/services/summary.service';
import { P5xService } from 'src/app/services/p5x.service';
import { DocumentService } from 'src/app/services/document.service';
import { SectionService } from 'src/app/services/section.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { ServerFailErrorComponent } from 'src/app/shared/components/server-fail-error/server-fail-error.component';
//#endregion

@Component({
  selector: 'app-guarantee-question2',
  templateUrl: './guarantee-question2.component.html',
  styleUrls: ['./guarantee-question2.component.css']
})
export class GuaranteeQuestion2Component implements OnInit, AfterViewChecked {
  //#region variables
  premiumAmount: number;
  premiumAmountStr: string;
  incDecValue: number;
  ensureYourContentChecked: boolean;
  ensuringContent: number;
  capitalContentValue: number;
  ensuringContentSubject;
  ensuringContentStr: string;
  capitalContentValueStr: string;
  capitlContentValueConstant: number;
  capitalContentValueConstantStr: string;
  contentUpToMaxError = false;
  contentDownToMinError = false;
  percent30MoreThanCapital = 0;
  disableBtnMinus = false;
  disableTxtCapitalContent = false;
  disableBtnPlus = false;
  disableBtnCalculate = true;
  disableBtnReset = true;
  tarifCheckboxStatus: TarifCheckboxStatus;
  initialPricingData: Pricing;
  updatedPricingData: Pricing;
  //#endregion

  //#region methods
  constructor(
    private guaranteeService: GuaranteeService, private notification: NotificationService,
    private translate: TranslateService, private globals: Globals, private decimalPipe: DecimalPipe, private matDialog: MatDialog,
    private summaryService: SummaryService, private p5xService: P5xService, private sectionService: SectionService) {
    this.guaranteeService.setshowNormalTitle(false);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P3-2');
    this.globals.trackPageActivity += ';' + 'P3-2';
    this.globals.calculateError = false;
    this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
    const contentCapitalGreaterThan30Percent = this.p5xService.getContentCapital();
    if (contentCapitalGreaterThan30Percent) {
      this.contentUpToMaxError = true;
    }
    this.initialPricingData = this.guaranteeService.getInitialPricingData();
    this.updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    this.tarifCheckboxStatus = this.guaranteeService.getTarifCheckboxStatus();
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.disableBtnCalculate = false;
      this.ensureYourContentChecked = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content_Checked;
      this.capitalContentValueConstantStr = this.initialPricingData.Evaluation.CapitalContenuEvalue;
      this.capitalContentValueStr = this.updatedPricingData.Tarification.CapitalContenuEvalue;
      this.capitlContentValueConstant = +this.capitalContentValueConstantStr.replace(',', '.');
      if (this.capitalContentValueConstantStr === this.capitalContentValueStr) {
        this.disableBtnMinus = true;
        this.disableTxtCapitalContent = true;
        this.disableBtnPlus = true;
        this.disableBtnCalculate = true;
        this.disableBtnReset = true;
      } else {
        this.disableBtnMinus = false;
        this.disableTxtCapitalContent = false;
        this.disableBtnPlus = false;
        this.disableBtnCalculate = false;
        this.disableBtnReset = false;
      }
      this.premiumAmountStr = this.updatedPricingData.Tarification.Premium_Total_Amount;
      this.ensuringContentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content;
      this.guaranteeService.setPremiumTotalAmount(this.updatedPricingData.Tarification.Premium_Total_Amount);
    } else {
      this.disableBtnCalculate = true;
      this.ensureYourContentChecked = this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked;
      this.premiumAmountStr = this.initialPricingData.Tarification.Premium_Total_Amount;
      this.guaranteeService.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
      this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
      if (this.ensureYourContentChecked) {
        this.disableBtnMinus = false;
        this.disableTxtCapitalContent = false;
        this.disableBtnPlus = false;
      } else {
        this.disableBtnMinus = true;
        this.disableTxtCapitalContent = true;
        this.disableBtnPlus = true;
      }
      this.capitalContentValueStr = this.initialPricingData.Tarification.CapitalContenuEvalue;
      this.capitalContentValueConstantStr = this.initialPricingData.Evaluation.CapitalContenuEvalue;
      this.capitlContentValueConstant = +this.capitalContentValueConstantStr.replace(',', '.');
    }
    this.premiumAmount = +this.premiumAmountStr.replace(',', '.');
    this.ensuringContent = +this.ensuringContentStr.replace(',', '.');
    if (this.guaranteeService.getensuringContentCalcFirstTime()) {
      this.calculatePremiumAmountOnInitialLoad();
    }

    const isPreviousP31Point1 = this.guaranteeService.getIsPreviousP31Point1();
    if (isPreviousP31Point1) {
      if (this.capitalContentValueStr === this.capitalContentValueConstantStr) {
        this.disableBtnCalculate = true;
        this.disableBtnReset = true;
      } else {
        this.disableBtnCalculate = false;
        this.disableBtnReset = false;
      }
    }
    const capitalBatimentStr = this.initialPricingData.Evaluation.CapitalBatimentEvalue;
    const capitalBatiment = +(capitalBatimentStr.replace(',', '.'));

    const capitalBatiment30Percent = (30 / 100) * capitalBatiment;
    this.percent30MoreThanCapital = +(this.decimalPipe.transform(capitalBatiment30Percent, '0.2-2').replace(',', ''));

    if (this.convertToNumber(this.capitalContentValueStr) > this.percent30MoreThanCapital) {
      this.contentUpToMaxError = true;
    }
    else{ this.contentUpToMaxError = false; this.p5xService.setContentCapital(false)}


  }

  calculatePremiumAmountOnInitialLoad() {
    this.premiumAmount = this.premiumAmount + this.ensuringContent;
    this.premiumAmountStr = this.decimalPipe.transform(this.premiumAmount, '0.2-2').replace(',', '');
    this.premiumAmountStr = this.premiumAmountStr.replace('.', ',');
    this.guaranteeService.setEnsuringContentCalcFirstTime(false);
    this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
    this.guaranteeService.setInitialPricingData(this.initialPricingData);
    this.guaranteeService.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
  }

  ngAfterViewChecked() {
    this.globals.guaranteeHeader2 = true;
  }

  onChange($event) {
  this.oncheckedChange($event.target.checked);
  }
oncheckedChange(isChecked)
{
  this.guaranteeService.setGuaranteeProgressBarDetails();
  if(this.globals.isMobile)
  {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
  if (isChecked) {
    this.guaranteeService.setUpdatedPricingData(null);
    this.guaranteeService.setContentCovering(true);
    this.p5xService.setTheftChecked(false);
    this.guaranteeService.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
    this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
    this.capitalContentValueStr = this.capitalContentValueConstantStr;
    this.initialPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
    this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked = true;
    this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
    this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
    this.premiumAmountStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Building;
    this.premiumAmount = this.convertToNumber(this.premiumAmountStr);
    this.premiumAmount = this.premiumAmount + this.convertToNumber(this.ensuringContentStr);
    this.premiumAmountStr = this.convertToString(this.premiumAmount);
    this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
    const backupFlight = this.guaranteeService.getBackupFlight();
    if (backupFlight !== undefined && backupFlight !== null) {
      const premiumAmountVatTheft = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft;
      const premiumAmountVatTheftNet = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Net;
      const premiumAmountVatTheftTax = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
      const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
      const premiumAmountVatTheftAdministration = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Administration;
        // this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = premiumAmountVatTheft;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
      this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
    }
    const legalProtectionStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
    const legalProtection = this.convertToNumber(legalProtectionStr);
    const deductableReimbursementStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund;
    const deductableReimbursement = this.convertToNumber(deductableReimbursementStr);
    const indirectLossesStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses;
    const indirectLosses = this.convertToNumber(indirectLossesStr);
    if (this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked) {
      this.premiumAmount = this.premiumAmount + legalProtection;
      this.premiumAmountStr = this.convertToString(this.premiumAmount);
    }
    if (this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked) {
      this.premiumAmount = this.premiumAmount + deductableReimbursement;
      this.premiumAmountStr = this.convertToString(this.premiumAmount);
    }
    if (this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked) {
      this.premiumAmount = this.premiumAmount + indirectLosses;
      this.premiumAmountStr = this.convertToString(this.premiumAmount);
    }
    this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
    this.guaranteeService.setPremiumTotalAmount(this.premiumAmountStr);
    this.disableBtnCalculate = true;
    this.disableBtnReset = true;
    this.ensureYourContentChecked = true;
    this.disableBtnMinus = false;
    this.disableTxtCapitalContent = false;
    this.disableBtnPlus = false;
    this.guaranteeService.setInitialPricingData(this.initialPricingData);
    this.tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked = true;
    this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
  } else {
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      if (this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
        const originalFlightValue = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
        this.resetPremiumAmount(originalFlightValue);
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft = originalFlightValue;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      }
    } else {
      if (this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked) {
        const originalFlightValue = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
        this.resetPremiumAmount(originalFlightValue);
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = originalFlightValue;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
    }
    this.guaranteeService.setContentCovering(false);
    this.p5xService.setTheftChecked(false);
    this.capitalContentValue = this.capitlContentValueConstant;
    this.p5xService.setContentCapital(false);
    this.capitalContentValueStr = this.decimalPipe.transform(this.capitalContentValue, '0.2-2').replace(',', '');
    this.capitalContentValueStr = this.capitalContentValueStr.replace('.', ',');
    this.updateTarificationCall('0');
    this.tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked = false;
    this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
  }
  this.contentDownToMinError = false;
  this.contentUpToMaxError = false;
  this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
}

  resetPremiumAmount(originalFlightValue) {
    const originalFlightValueNum = +originalFlightValue.replace(',', '.');
    let premiumTotalAmountStr;
    let currentFlightValue;
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      currentFlightValue = +this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
      premiumTotalAmountStr = this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Total_Amount.toString();
    } else {
      currentFlightValue = +this.guaranteeService.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
      premiumTotalAmountStr = this.guaranteeService.getInitialPricingData().Tarification.Premium_Total_Amount.toString();
    }
    const premiumTotalAmount = +(premiumTotalAmountStr.replace(',', '.')) -
      (+(this.decimalPipe.transform(currentFlightValue, '0.2-2').replace(',', ''))) + originalFlightValueNum;
    premiumTotalAmountStr = this.decimalPipe.transform(premiumTotalAmount, '0.2-2').replace(',', '').replace('.', ',');
    this.guaranteeService.setPremiumTotalAmount(premiumTotalAmountStr);
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
    } else {
      this.initialPricingData.Tarification.Premium_Total_Amount = premiumTotalAmountStr;
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
    }
  }

  onDec() {
    this.disableBtnCalculate = false;
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(false);
    const value = +this.capitalContentValueStr.replace(',', '.');
    if (value - 1000 <= 0) {
      this.contentDownToMinError = false;
      this.capitalContentValue = this.capitlContentValueConstant;
      this.capitalContentValueStr = this.decimalPipe.transform(this.capitalContentValue, '0.2-2').replace(',', '');
      this.capitalContentValueStr = this.capitalContentValueStr.replace('.', ',');
      this.updateTarificationCall('0');
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
    } else {
      this.contentDownToMinError = false;
      const remainder = value % 1000;
      if (remainder === 0) {
        this.capitalContentValue = Math.round(+(this.capitalContentValueStr.replace(',', '.')));
        this.capitalContentValue -= 1000;
      } else {
        this.capitalContentValue = value - remainder;
      }
      this.capitalContentValueStr = this.decimalPipe.transform(this.capitalContentValue, '0.2-2').replace(',', '');
      this.capitalContentValueStr = this.capitalContentValueStr.replace('.', ',');
      // if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      //   this.updatedPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
      //   this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      // } else {
      //   this.initialPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
      //   this.guaranteeService.setInitialPricingData(this.initialPricingData);
      // }
    }
    if (this.capitalContentValue < this.capitlContentValueConstant) {
      this.contentDownToMinError = true;
    } else {
      this.contentDownToMinError = false;
    }
    if (this.capitalContentValue < this.percent30MoreThanCapital) {
      this.contentUpToMaxError = false;
    }
    if (this.capitalContentValue > this.percent30MoreThanCapital) {
      this.summaryService.setCapitalContentWarningStatus(true);
      this.p5xService.setContentCapital(true);
    } else {
      this.summaryService.setCapitalContentWarningStatus(false);
      this.p5xService.setContentCapital(false);
    }
    this.setDisableForBtnCalculateAndBtnReset();
  }

  onInc() {
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    const value = +this.capitalContentValueStr.replace(',', '.');
    const remainder = value % 1000;
    if (remainder === 0) {
      this.capitalContentValue = Math.round(+(this.capitalContentValueStr.replace(',', '.')));
      this.capitalContentValue += 1000;
    } else {
      this.capitalContentValue = value + 1000 - remainder;
    }
    this.capitalContentValueStr = this.decimalPipe.transform(this.capitalContentValue, '0.2-2').replace(',', '');
    this.capitalContentValueStr = this.capitalContentValueStr.replace('.', ',');
    this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(false);
    if (this.capitalContentValue > this.percent30MoreThanCapital) {
      this.contentUpToMaxError = true;
    }
    else{ this.contentUpToMaxError = false;}
    if (this.capitalContentValue > this.capitlContentValueConstant) {
      this.contentDownToMinError = false;
    }
    if (this.capitalContentValue > this.percent30MoreThanCapital) {
      this.summaryService.setCapitalContentWarningStatus(true);
      this.p5xService.setContentCapital(true);
    } else {
      this.summaryService.setCapitalContentWarningStatus(false);
      this.p5xService.setContentCapital(false);
    }
    this.setDisableForBtnCalculateAndBtnReset();
  }

  onCapitalContentValueChange(valueStr) {
    this.contentUpToMaxError = false;
    this.contentDownToMinError = false;
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    const value = +valueStr.replace(',', '.');
    if (valueStr === '' || value === 0) {
      this.contentDownToMinError = false;
      this.capitalContentValue = this.capitlContentValueConstant;
      this.capitalContentValueStr = this.decimalPipe.transform(this.capitalContentValue, '0.2-2').replace(',', '');
      this.capitalContentValueStr = this.capitalContentValueStr.replace('.', ',');
     // this.updateTarificationCall('0');
     this.oncheckedChange(false);
      this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
    } else {
      if (value > this.percent30MoreThanCapital) {
        this.contentUpToMaxError = true;
        this.contentDownToMinError = false;
        this.p5xService.setContentCapital(true);
      } else if (value < this.capitlContentValueConstant) {
        this.contentUpToMaxError = false;
        this.contentDownToMinError = true;
        this.p5xService.setContentCapital(false);
        this.summaryService.setCapitalContentWarningStatus(false);
      }
      this.capitalContentValue = value;
      if (value === this.capitlContentValueConstant) {
        this.globals.calculateError = false;
        this.contentUpToMaxError = false;
        this.contentDownToMinError = false;
        this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
      } else {
        this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(false);
      }
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
      if (value > this.percent30MoreThanCapital) {
        this.p5xService.setContentCapital(true);
      } else {
        this.p5xService.setContentCapital(false);
      }
    }
    this.setDisableForBtnCalculateAndBtnReset();
  }

  setDisableForBtnCalculateAndBtnReset() {
    if (this.capitalContentValueStr === this.capitalContentValueConstantStr) {
      this.disableBtnCalculate = true;
      this.disableBtnReset = true;
    } else {
      this.disableBtnCalculate = false;
      this.disableBtnReset = false;
    }
  }

  convertToString(value: number): string {
    let valueStr = this.decimalPipe.transform(value, '0.2-2').replace(',', '');
    valueStr = valueStr.replace('.', ',');
    return valueStr;
  }

  convertToNumber(value: string): number {
    return +(value.replace(',', '.'));
  }

  isNumber(evt) {
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  btnCalculate() {
    // const input1 = {
    //   title: this.translate.instant('Msg_Info_Title'), 
    //   errorMessage: this.translate.instant('Msg_2minutes_Delay'),
    //   disableClose: false};
    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    // dialogConfig.data = input1; 
    // const dialogRef = this.matDialog.open(ServerFailErrorComponent, dialogConfig);
    // dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      this.globals.calculateError = false;
      this.guaranteeService.setGuaranteeProgressBarDetails();
      if(this.globals.isMobile)
      {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
      this.updateTarificationCall(this.capitalContentValue);
      this.guaranteeService.setBtnCalculateClickedChk(true);
      this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
    // });
  }

  updateTarificationCall(capitalContenu) {
    this.globals.showLoaderText = true;
    this.globals.showprojectText = false;
    const request = this.guaranteeService.updateTarifRequest('false', capitalContenu);
    this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
    this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    this.guaranteeService.getUpdatedTarificationEvaluationApi(request).subscribe((response) => {
      if (capitalContenu === '0') {
        this.capitalContentValueStr = this.capitalContentValueConstantStr;
      } else {
        this.capitalContentValueStr = this.decimalPipe.transform(capitalContenu, '0.2-2').replace(',', '').replace('.', ',');
      }
      this.updatedPricingData = this.guaranteeService.updateTarifEnsuringContentCalculation(this.capitalContentValueStr, response);
      this.ensuringContentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content;
      this.guaranteeService.setBtnCalculateClickedChk(true);
      this.globals.calculateError = false;
      this.globals.showLoaderText = false;
    });
    if (capitalContenu === '0') {
      this.capitalContentValue = this.convertToNumber(this.capitalContentValueStr);
      this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked = false;
      this.ensureYourContentChecked = false;
      this.disableBtnMinus = true;
      this.disableTxtCapitalContent = true;
      this.disableBtnPlus = true;
      this.disableBtnCalculate = true;
      this.disableBtnReset = true;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumAmountStr;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      }
    }
  }

  btnReset() {
    this.guaranteeService.setGuaranteeProgressBarDetails();
    if(this.globals.isMobile)
    {this.guaranteeService.setmobileGuaranteeProgressBarDetails();}
    this.guaranteeService.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
    this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
    this.capitalContentValueStr = this.capitalContentValueConstantStr;
    this.initialPricingData.Tarification.CapitalContenuEvalue = this.capitalContentValueStr;
    this.guaranteeService.setInitialPricingData(this.initialPricingData);
    this.disableBtnCalculate = true;
    this.disableBtnReset = true;
    this.contentUpToMaxError = false;
    this.contentDownToMinError = false;
    this.globals.calculateError = false;
    this.guaranteeService.setUpdatedPricingData(null);
    this.guaranteeService.setBtnCalculateClickedChk(false);
    this.p5xService.setContentCapital(false);
    this.guaranteeService.setContentCovering(true);
    this.guaranteeService.setCalculatedPremiumAfterUpdatingCapital(true);
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
